/* eslint-disable react/no-array-index-key */
import React from 'react';
import styled from 'styled-components';
import uuid from 'uuid';
import { Table } from '../../../../components/elements';

const PlaceBookingStatisticsContainer = styled.div`
  padding: 10px;
  fontweight: 700;
`;

const PlaceBookingStatistics = ({ placeBookingStatistics, loading }) => (
  <PlaceBookingStatisticsContainer>
    <Table>
      <thead style={{ backgroundColor: '#d0d0d0' }}>
        <tr>
          {['Bookings', 'Cancellations', 'Guests', 'Payments', 'Refunds'].map(
            (headerCellValue, index) => (
              <th
                style={{ border: '1px solid black', fontWeight: 700 }}
                key={`${headerCellValue}-${index}`}
              >
                <div>
                  <span>{headerCellValue}</span>
                </div>
              </th>
            ),
          )}
        </tr>
      </thead>
      <tbody style={{ fontWeight: 700 }}>
        <tr>
          {loading ||
          placeBookingStatistics === null ||
          placeBookingStatistics === undefined
            ? Array.from({ length: 5 }, () => (
                <td
                  style={{
                    border: '1px solid black',
                    backgroundColor: '#d0d0d0',
                  }}
                  key={uuid()}
                >
                  -
                </td>
              ))
            : [
                placeBookingStatistics.total_bookings,
                placeBookingStatistics.cancelled_count,
                placeBookingStatistics.total_guests,
                !placeBookingStatistics.payment
                  ? '-'
                  : `$${parseFloat(placeBookingStatistics.payment).toFixed(2)}`,
                !placeBookingStatistics.refund_amount
                  ? '-'
                  : `-$${Math.abs(
                      parseFloat(placeBookingStatistics.refund_amount),
                    ).toFixed(2)}`,
              ].map((bodyCellValue, index) => (
                <td
                  style={{
                    border: '1px solid black',
                    backgroundColor: '#d0d0d0',
                  }}
                  key={`${bodyCellValue}-${index}`}
                >
                  {bodyCellValue}
                </td>
              ))}
        </tr>
      </tbody>
    </Table>
  </PlaceBookingStatisticsContainer>
);

export default PlaceBookingStatistics;
